(() => {
  const initialized = new WeakSet();

  const init = () => {
    const reveals = document.querySelectorAll('.chak-reveal');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.14 });
      reveals.forEach((el) => observer.observe(el));
    } else {
      reveals.forEach((el) => el.classList.add('is-visible'));
    }

    document.querySelectorAll('[data-chak-open-film]').forEach((button) => {
      button.addEventListener('click', () => {
        const dialog = document.getElementById(button.getAttribute('aria-controls'));
        if (dialog?.showModal) dialog.showModal();
      });
    });
    document.querySelectorAll('[data-chak-close-film]').forEach((button) => {
      button.addEventListener('click', () => {
        const dialog = button.closest('dialog');
        const video = dialog?.querySelector('video');
        video?.pause();
        dialog?.close();
      });
    });

    document.querySelectorAll('[data-chak-product-carousel]').forEach((carousel) => {
      if (initialized.has(carousel)) return;
      initialized.add(carousel);
      const track = carousel.querySelector('[data-chak-carousel-track]');
      const move = (direction) => {
        const card = track?.querySelector('.chak-product');
        if (!track || !card) return;
        track.scrollBy({ left: direction * card.getBoundingClientRect().width * 2, behavior: 'smooth' });
      };
      carousel.querySelector('[data-chak-carousel-prev]')?.addEventListener('click', () => move(-1));
      carousel.querySelector('[data-chak-carousel-next]')?.addEventListener('click', () => move(1));
    });

    document.querySelectorAll('[data-chak-slideshow]').forEach((slideshow) => {
      if (initialized.has(slideshow)) return;
      initialized.add(slideshow);
      const slides = [...slideshow.querySelectorAll('[data-chak-slide]')];
      const dots = [...slideshow.querySelectorAll('[data-chak-slide-dot]')];
      if (slides.length < 2) return;
      let current = 0;
      let timer;
      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === current));
      };
      const restart = () => {
        window.clearInterval(timer);
        if (slideshow.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          timer = window.setInterval(() => show(current + 1), Number(slideshow.dataset.interval) || 6000);
        }
      };
      slideshow.querySelector('[data-chak-slide-prev]')?.addEventListener('click', () => { show(current - 1); restart(); });
      slideshow.querySelector('[data-chak-slide-next]')?.addEventListener('click', () => { show(current + 1); restart(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.chakSlideDot)); restart(); }));
      slideshow.addEventListener('mouseenter', () => window.clearInterval(timer));
      slideshow.addEventListener('mouseleave', restart);
      slideshow.addEventListener('shopify:block:select', (event) => {
        const selected = slides.indexOf(event.target);
        if (selected >= 0) show(selected);
        window.clearInterval(timer);
      });
      restart();
    });

    // Some POD integrations add one mockup per color without assigning every
    // mockup as Shopify's featured variant image. In that case the variant
    // changes, but the gallery can remain on the first color. Match the chosen
    // color to the mockup filename/alt text and select its gallery slide.
    const syncProductColorMedia = () => {
      const selectedColor = document.querySelector(
        'input[type="radio"][data-option-name="Color"]:checked, input[type="radio"][data-option-name="Colour"]:checked'
      );
      const gallery = document.querySelector('media-gallery');
      if (!selectedColor || !gallery) return;

      const colorSlug = selectedColor.value
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-');
      const slides = [...gallery.querySelectorAll('slideshow-slide')];
      const matchingIndex = slides.findIndex((slide) => {
        const image = slide.querySelector('img');
        const source = `${image?.currentSrc || image?.src || ''} ${image?.alt || ''}`
          .toLowerCase()
          .replace(/%20/g, '-');
        return source.includes(`-${colorSlug}-`);
      });

      if (matchingIndex >= 0) {
        const slideshow = gallery.querySelector('slideshow-component');
        if (typeof slideshow?.select === 'function') {
          slideshow.select(matchingIndex, undefined, { animate: false });
        } else {
          // Safe fallback while the custom element is still initializing.
          const scroller = gallery.querySelector('slideshow-slides');
          const targetSlide = slides[matchingIndex];
          scroller?.scrollTo({ left: targetSlide.offsetLeft, behavior: 'instant' });
        }
      }
    };

    if (!document.documentElement.dataset.chakColorMediaReady) {
      document.documentElement.dataset.chakColorMediaReady = 'true';
      document.addEventListener('change', (event) => {
        if (!event.target?.matches?.(
          'input[type="radio"][data-option-name="Color"], input[type="radio"][data-option-name="Colour"]'
        )) return;

        // Select the matching slide immediately in the existing gallery.
        syncProductColorMedia();
      });

      // Fabric replaces the entire gallery after a variant selection. Correct
      // the newly inserted gallery in the same rendering cycle, before an
      // unrelated first slide can flash on screen.
      const productMediaObserver = new MutationObserver((mutations) => {
        const galleryWasReplaced = mutations.some((mutation) =>
          [...mutation.addedNodes].some((node) =>
            node.nodeType === 1 && (
              node.matches?.('media-gallery') || node.querySelector?.('media-gallery')
            )
          )
        );
        if (!galleryWasReplaced) return;
        syncProductColorMedia();
        window.requestAnimationFrame(syncProductColorMedia);
      });
      productMediaObserver.observe(document.querySelector('main') || document.body, {
        childList: true,
        subtree: true,
      });
    }

    window.setTimeout(syncProductColorMedia, 150);
  };
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
